/**
 * Extracts a string message from any thrown value, including Tauri IPC errors
 * which arrive as plain objects (not Error instances).
 */
export function extractErrorMessage(err: unknown): string {
  if (err instanceof Error) return err.message;
  if (typeof err === 'string') return err;
  if (err !== null && typeof err === 'object') {
    const obj = err as Record<string, unknown>;
    if (typeof obj.message === 'string') return obj.message;
  }
  return String(err);
}
